<template>
  <div class="checkbox uk-form-controls uk-margin">
    <label :class="{ 'uk-text-danger': isInvalid }">
      <input
        :class="inputCss"
        :disabled="disabled"
        @change="onChange"
        class="checkbox__input uk-checkbox"
        ref="primaryInput"
        type="checkbox"
        v-model="internalValue"
      />
      <slot name="label">
        <template v-if="label">{{label}}</template>
      </slot>
      <validation-hint :errors="internalErrors" />
    </label>
  </div>
</template>

<script>
import Input from '@/mixins/Input';
import ValidationHint from '@/components/ValidationHint';

export default {
  name: 'checkbox',
  components: {
    ValidationHint,
  },
  mixins: [Input],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onChange() {
      this.clearErrors();
      this.$emit('input', this.internalValue);
      this.$emit('change', this.internalValue);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../theme/variables.scss";

.checkbox {
  width: fit-content;

  &__input.uk-form-danger {
    border-color: $alert-danger-color;
  }
}
</style>



// WEBPACK FOOTER //
// Checkbox.vue?3a53525c